import _ from 'lodash'
import { RootState } from '../../types/RootState'
import { createSelector } from '@reduxjs/toolkit'

class DeadLetterEventsSelectors {
  getDeadLetterEvents = (state: RootState) => state.deadLetterEvents.deadLetterEvents
  getPaginationTimestamp = createSelector(
    [
      (state: RootState) => {
        const createdTimestamp =
          state.deadLetterEvents.deadLetterEvents[
            state.deadLetterEvents.deadLetterEvents.length - 1
          ]?.createdTimestamp
        return createdTimestamp
      },
    ],
    createdTimestamp => {
      if (createdTimestamp) {
        return new Date(createdTimestamp)
      }
    },
  )
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.deadLetterEvents.status === 'initial' ||
            state.deadLetterEvents.status === 'loading'
          : state.deadLetterEvents.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  getInitial = (state: RootState) => state.deadLetterEvents.status === 'initial'
  getHasError = (state: RootState) => state.deadLetterEvents.status === 'failed'
  getError = (state: RootState) => state.deadLetterEvents.error
}

export default new DeadLetterEventsSelectors()
